import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';
import { buildColorPalette, getClosestColorShade } from './utils';

const BASE_THEME = Aura;
const PRIMARY_COLOR = 'slate'; // default: slate
const PRIMARY_COLOR_SHADE = 950; // default: 950

export const CustomTheme = definePreset(BASE_THEME, {
  semantic: {
    primary: buildColorPalette(PRIMARY_COLOR),
    colorScheme: {
      light: {
        primary: {
          color: `{primary.${getClosestColorShade(PRIMARY_COLOR_SHADE)}}`, // 950
          contrastColor: '#ffffff',
          hoverColor: `{primary.${getClosestColorShade(PRIMARY_COLOR_SHADE - 250)}}`, // 800
          activeColor: `{primary.${getClosestColorShade(PRIMARY_COLOR_SHADE - 350)}}`, // 700
        },
        highlight: {
          background: `{primary.${getClosestColorShade(PRIMARY_COLOR_SHADE - 350)}}`, // 950
          focusBackground: `{primary.${getClosestColorShade(PRIMARY_COLOR_SHADE - 350)}}`, // 700
          color: '#ffffff',
          focusColor: '#ffffff',
        },
      },
      dark: {
        primary: {
          color: `{primary.50}`,
          contrastColor: `{primary.950}`,
          hoverColor: `{primary.200}`,
          activeColor: `{primary.300}`,
        },
        highlight: {
          background: `{primary.50}`,
          focusBackground: `{primary.300}`,
          color: `{primary.950}`,
          focusColor: `{primary.950}`,
        },
      },
    },
  },
} satisfies typeof BASE_THEME);
